module.exports = __webpack_public_path__ + "static/media/468x60_0077_en.a6a4ad60.jpg";